import { OutcomeConfig } from 'Rewards/services/endpoints/GetRewardsConfig/types';

// Number of policies an agent must bind to earn one spin entry.
export const POLICIES_PER_ENTRY = 5;

// Each prize appears this many times on the wheel for visual balance.
// All segments have equal weight so the wheel geometry is uniform; the actual
// probability is determined server-side at attempt resolution time.
export const SEGMENT_REPEATS = 3;

export const SPIN_DURATION_MS = 8200;
export const SPIN_REVOLUTIONS = 9;

export type WheelSegment = {
  /** Index into the outcomes array this segment belongs to. */
  prizeIndex: number;
};

/**
 * Returns the ordered list of wheel segments.
 * Layout: [outcome0, outcome1, ..., outcomeN, outcome0, ...] × SEGMENT_REPEATS
 */
export function buildSegments(outcomes: OutcomeConfig[]): WheelSegment[] {
  const segments: WheelSegment[] = [];
  for (let r = 0; r < SEGMENT_REPEATS; r++) {
    for (let oi = 0; oi < outcomes.length; oi++) {
      segments.push({ prizeIndex: oi });
    }
  }
  return segments;
}

/**
 * Returns the segment indexes that correspond to a given prize index.
 * Used to pick a random visual landing point among the matching segments.
 */
export function findMatchingSegmentIndexes(
  outcomes: OutcomeConfig[],
  prizeIndex: number
): number[] {
  return buildSegments(outcomes)
    .map((segment, i) => ({ segment, i }))
    .filter(({ segment }) => segment.prizeIndex === prizeIndex)
    .map(({ i }) => i);
}

/** Cubic ease-in-out — smooth deceleration that feels intentional, not abrupt. */
export function easeInOutCubic(t: number): number {
  return t < 0.5 ? 4 * Math.pow(t, 3) : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
